import { Phone } from "lucide-react";
import { IMAGES, handleCallClick } from "./constants";

export default function Hero() {
  return (
    <header className="relative px-6 pt-16 pb-24 border-b border-white/10 overflow-hidden bg-[#0b101b]">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-950/60 border border-cyan-500/30 text-cyan-300 font-mono-lbl text-xs uppercase mb-6">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-ping"></span>
            Dayton &amp; Cincinnati Mobile Mechanics
          </div>
          <h1 className="text-4xl sm:text-6xl font-black tracking-tight leading-[1.05] uppercase">
            <span className="ln">
              <span>Fast Mobile Repairs</span>
            </span>
            <span className="ln">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff4b2b] via-[#ff7643] to-[#00e5ff]">
                Right Where You Are
              </span>
            </span>
          </h1>
          <p className="hero-sub mt-6 text-slate-300 text-lg leading-relaxed max-w-xl">
            I come to you &middot; no towing, no waiting at a shop. Fast response,
            often same-day. Honest upfront pricing, cheaper than a shop.
          </p>
          <div className="hero-cta mt-8 flex flex-wrap items-center gap-4">
            <a
              href="#quote"
              data-testid="hero-book-service-button"
              className="bg-[#ff4b2b] text-white px-7 py-3.5 rounded-lg font-bold text-sm tracking-wide uppercase hover:bg-[#ff3411] transition-colors shadow-xl shadow-[#ff4b2b]/25"
            >
              Book Service Van
            </a>
            <button
              type="button"
              onClick={handleCallClick}
              data-testid="hero-call-mechanic-button"
              className="border border-white/20 hover:border-white/50 px-6 py-3.5 rounded-lg font-mono-lbl text-xs text-white uppercase tracking-wider transition-colors flex items-center gap-2"
            >
              <Phone className="w-4 h-4 text-[#00e5ff]" />
              <span>Tap to Call Mechanic</span>
            </button>
          </div>
        </div>

        <div className="lg:col-span-5 hero-card">
          <div className="relative rounded-2xl overflow-hidden border border-white/15 p-1 bg-gradient-to-br from-white/10 to-transparent shadow-2xl">
            <div className="h-80 sm:h-96 rounded-xl relative overflow-hidden img-drift flex flex-col justify-end">
              <img
                src={IMAGES.heroVan}
                alt="Mobile mechanic van equipped with diagnostic tools on route"
                data-testid="hero-van-image"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="relative z-10 flex items-center justify-between p-6">
                <div>
                  <p className="font-mono-lbl text-xs text-cyan-300 uppercase">Unit On Route</p>
                  <p className="font-bold text-white text-lg">On-Site Dispatch</p>
                </div>
                <span className="px-3 py-1 bg-emerald-500/20 text-emerald-300 text-xs font-mono-lbl border border-emerald-500/40 rounded-full">
                  Dayton&ndash;Cincy Area
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
